import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/layout/Layout/Layout";
import LoginPage from "./pages/login/login";
import SignupPage from "./pages/login/signup";
import AngelLoginPage, { AuthCallback } from "./pages/login/angellogin";
import ProtectedRoute from "./components/ProtectedRoute";
import AccessDenied from "./components/common/AccessDenied/AccessDenied.jsx";
import routeConfig from "./routeConfig";

/**
 * AppRoutes — renders every <Route> in the application.
 *
 * Standard protected routes are driven by routeConfig (one object
 * per page). One-off routes (login, signup, auth callback,
 * access-denied) are defined inline below because they don't
 * follow the <ProtectedRoute><Layout> pattern and there's no
 * benefit in abstracting them into the config array.
 */
const AppRoutes = () => (
  <Routes>
    {/* ── Auth / public routes ──────────────────────────── */}
    <Route path="/auth/callback" element={<AuthCallback />} />
    <Route path="/AngelLoginPage" element={<AngelLoginPage />} />
    <Route
      path="/"
      element={
        localStorage.getItem("userSession") ? (
          <Navigate to="/home" replace />
        ) : (
          <LoginPage />
        )
      }
    />
    <Route path="/signup" element={<SignupPage />} />

    {/* ── Protected routes (config-driven) ─────────────── */}
    {routeConfig.map(({ path, component: Component, permission, layoutProps }) => (
      <Route
        key={path}
        path={path}
        element={
          <ProtectedRoute permission={permission}>
            <Layout {...(layoutProps || {})}>
              <Component />
            </Layout>
          </ProtectedRoute>
        }
      />
    ))}

    {/* ── Access denied (no ProtectedRoute wrapper) ─────── */}
    <Route
      path="/access-denied"
      element={
        <Layout>
          <AccessDenied />
        </Layout>
      }
    />
  </Routes>
);

export default AppRoutes;
